import React from 'react'
import { ROLES, clientTabs } from 'config'
import { navigateTo } from 'utils/helper'

const DictionaryList = ({ children, client }) => {
  return (
    <div
      className="group cursor-pointer hover:bg-grey-light transition-colors"
      onClick={() => {
        if (window.location.href.includes(ROLES.BSO_ADVISOR)) {
          navigateTo(ROLES.BSO_ADVISOR, `clients/${client?.id}/${clientTabs[0].name}`)
        } else {
          navigateTo(ROLES.BSO_ADMIN, `clients/${client?.id}/${clientTabs[0].name}`)
        }
      }}
    >
      <div className="border-b border-grey-lighter pl-6 pr-3 py-4">
        <div className="flex justify-between items-center gap-2">{children}</div>
      </div>
    </div>
  )
}

export default DictionaryList
